import { render, staticRenderFns } from "./EditRegNote.vue?vue&type=template&id=122db88c&scoped=true"
import script from "./EditRegNote.vue?vue&type=script&lang=js"
export * from "./EditRegNote.vue?vue&type=script&lang=js"
import style0 from "./EditRegNote.vue?vue&type=style&index=0&id=122db88c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122db88c",
  null
  
)

export default component.exports